export default __webpack_public_path__ + "ec23460cc2ae1dbae035a446f999cd72.png";